import i18next from "i18next";
import {
    DEFAULT_LOCALE,
} from "./settings";

import EN_US from "./locales/EN_US";

i18next.init({
    lng: DEFAULT_LOCALE,
    resources: {
        EN_US: {
            translation: EN_US,
        },
    },
});



// WEBPACK FOOTER //
// ./src/i18n.ts